import { AlertResponse, MediasResponse } from "../types/media";
import { TaskLinks } from "../types/taskLink";
import { MediasViewListMobile } from "./MediasViewListMobile";
import { MediasViewArticleListMobile } from "./MediasViewArticleListMobile";
import { GreyRow } from "../styles/styles";
import { Trans } from "@coworker/locales";
import { ArticleWithMediaCount } from "../types/article";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

interface MediasViewSearchListMobileProps {
  mediasResponse: MediasResponse | undefined;
  taskCountsByMediaId: Map<string, number>;
  taskLinks: TaskLinks;
  alerts: AlertResponse[] | undefined;
  storeId: string;
  articles: ArticleWithMediaCount[] | undefined;
}

export function MediasViewSearchListMobile({
  mediasResponse,
  taskCountsByMediaId,
  taskLinks,
  alerts,
  storeId,
  articles,
}: MediasViewSearchListMobileProps) {
  return (
    <>
      <MediasViewListMobile
        mediasResponse={mediasResponse}
        taskCountsByMediaId={taskCountsByMediaId}
        alerts={alerts}
      />

      {!!articles && articles.length > 0 && (
        <GreyRow>
          <FixaText>
            <b>
              <Trans count={articles?.length ?? 0}>countArticlesString</Trans>
            </b>
          </FixaText>
        </GreyRow>
      )}
      <MediasViewArticleListMobile
        articles={articles}
        taskLinks={taskLinks}
        storeId={storeId}
      />
    </>
  );
}
